import { useEffect } from "react";
import PropTypes from "prop-types";
import { faArrowRotateBack } from "@fortawesome/free-solid-svg-icons";
import { useHistorialSolicitudes } from "../useHistorialSolicitudes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { customStyles } from "../../../utils/Constants";
import Spinner from "../../../components/ui/Spinner";
import DataTable from "react-data-table-component";
import { useLocation } from "react-router-dom";

export const ModalBodylHistorial = ({ fnAtras, id = 0 }) => {
  const { traerHistorial, historial, arrColumnas } =
    useHistorialSolicitudes(id);
  const location = useLocation();

  useEffect(() => {
    document.querySelector(".modal-header h5").innerText = "Historial";
    traerHistorial({ id });
  }, []);

  return (
    <div className="pb-3 px-1">
      {historial ? (
        <div className="mb-3">
          <DataTable
            dense
            data={historial}
            columns={arrColumnas}
            customStyles={customStyles}
          />
        </div>
      ) : (
        <div className="d-flex flex-row justify-content-center align-items-center">
          <h2 className="me-2">Cargando</h2>
          <Spinner />
        </div>
      )}
      <div className="d-flex justify-content-end">
        {location.pathname !== "/historial-solicitudes" && (
          <button
            className={`btn gap-2 d-flex align-items-center py-1 btn-success btn-sm`}
            data-bs-toggle="tooltip"
            title="Volver"
            onClick={() => {
              document.querySelector(".modal-header h5").innerText =
                "Datos de solicitud";
              fnAtras();
            }}
          >
            Volver <FontAwesomeIcon icon={faArrowRotateBack} />
          </button>
        )}
      </div>
    </div>
  );
};

ModalBodylHistorial.propTypes = {
  fnAtras: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
